import { Alert, Checkbox, Col, Descriptions, Row } from "antd";
import { IRepairCase, IRepairCaseFetchingInfo, IRepairCaseInitialData, IRepairCaseProps, IRepairCaseStates, enmRepairCaseStatus, enmRepairationStatus, repairCaseStatusOptions, repairationStatusOptions, sendMethodsOptions } from "../../baseInfo/repairCase/interfaces";
import { BaseEntityManager } from "../../components/entityManager";
import { IMetadata, enmControlType, enmEntityManagerState, enmPropertyType } from "../../components/entityManager/interfaces";
import AppContext, { AppContextProps } from "../../components/infrastructure/appContext";
import { ICallOptions, IResultSet, enmOrderingType } from "../../components/infrastructure/models";
import { InfoCircleFilled } from "@ant-design/icons";
import { AttachmentViewer } from "../../baseInfo/attachment/attachmentViewer";
import dayjs from 'dayjs';
import { IRepairationActionProps } from "../../repairation/repairCaseCenter/interfaces";
import * as RepairationComponents from '../../repairation/repairCaseCenter/components';
import SimpleMap from "../../components/map";
import { CustomerConfirmation } from "../../repairation/repairCaseCenter/customerConfirmation";
import TextArea from "antd/lib/input/TextArea";
import { IProblem } from "../../baseInfo/problem/interfaces";

const ProblemsList = (props: { items: IProblem[] }) => {
    const list = props.items.map(item =>
        <Descriptions.Item key={item.Id} >
            <Checkbox checked >
                {item.Name}
            </Checkbox>
        </Descriptions.Item>);
    return (
        <Descriptions key="ProblemsList" layout='horizontal' column={{ xxl: 8, xl: 6, lg: 4, md: 3, sm: 2, xs: 1 }}>
            {list}
        </Descriptions>
    );
}

const CenterLocation = (center: { Longitude?: number; Latitude?: number; Address?: string; WorkTime?: string; CityName?: string; Phone?: string; }) => {
    return (
        !!center.Longitude && !!center.Latitude ?
            <div style={{ maxWidth: 400 }}>
                <Row>
                    <Col style={{ zIndex: 0 }}>
                        <Descriptions >
                            <Descriptions.Item label={"آدرس"}> {center.Address}</Descriptions.Item>
                        </Descriptions>
                    </Col>
                    {!!center.Phone &&
                        <Col style={{ zIndex: 0 }}>
                            <Descriptions>
                                <Descriptions.Item label={"تلفن"}>
                                    <b style={{ unicodeBidi: "plaintext" }}>{center.Phone.startsWith('9') ? `0${center.Phone}` : `0${center.Phone}`.replace(/\D+/g, '').replace(/(\d{3})(\d+)/, '$1 - $2')}</b>
                                </Descriptions.Item>
                            </Descriptions>
                        </Col>
                    }
                    {!!center.WorkTime &&
                        <Col style={{ zIndex: 0 }}>
                            <Descriptions key="workTime">
                                <Descriptions.Item label={"ساعت کار"} > {center.WorkTime}</Descriptions.Item>
                            </Descriptions>
                        </Col>
                    }
                    {!!center.Latitude &&
                        <Col style={{ zIndex: 0 }}>
                            <Descriptions key="map" style={{ zIndex: 0 }}>
                                <Descriptions.Item>
                                    <SimpleMap
                                        disableChangeMarker={true}
                                        cityName={center.CityName}
                                        lat={center.Latitude}
                                        lng={center.Longitude}
                                    />
                                </Descriptions.Item>
                            </Descriptions>
                        </Col>
                    }
                </Row>
            </div>
            :
            <></>
    );
}

export class RepairCasePolicyholder extends BaseEntityManager<IRepairCase, IRepairCaseProps, IRepairCaseStates, IRepairCaseFetchingInfo, IRepairCaseInitialData>{
    static initMetadata = (): IMetadata => {
        return {
            title: "لیست درخواست های تعمیرات (آزاد)",
            name: "RepairCasePolicyholder",
            Properties: [
                {
                    title: "شماره پیگیری",
                    dataIndex: "TicketNo",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.numberinput,
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "شماره پرونده",
                    dataIndex: "Code",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.numberinput,
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "وضعیت پرونده",
                    dataIndex: "Status",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.combobox,
                    combobox: {
                        options: repairCaseStatusOptions
                    },
                    disabled: true,
                    filterable: true,
                    width: 200
                },
                {
                    title: "وضعیت تعمیرات",
                    dataIndex: "RepairationStatus",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.combobox,
                    combobox: {
                        optionsFunc: () => repairationStatusOptions.map(o => {
                            return { title: o.userCartableTitle, value: o.value, name: o.name };
                        })
                    },
                    disabled: true,
                    filterable: false,
                    sortable: false,
                    width: 200
                },
                {
                    title: "IMEI/سریال دستگاه",
                    dataIndex: "CustomerEquipmentModel.EquipmentSerialNo",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150
                },
                {
                    title: "کد ملی مشتری",
                    dataIndex: "CustomerEquipmentModel.Customer.NationalCode",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150
                },
                {
                    title: "مشتری",
                    dataIndex: "CustomerEquipmentModel.Customer.FullName",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.textbox,
                    filterable: false,
                    sortable: false,
                    width: 200
                },
                {
                    title: "نوع تجهیز",
                    dataIndex: "CustomerEquipmentModel.Equipment.Name",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 120
                },
                {
                    title: "برند",
                    dataIndex: "CustomerEquipmentModel.BrandTitle",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    sortable: true,
                    width: 120
                },
                {
                    title: "مدل",
                    dataIndex: "CustomerEquipmentModel.EquipmentModelTitle",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    sortable: true,
                    width: 120
                },
                {
                    title: "روش ارسال",
                    dataIndex: "SendMethod",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.combobox,
                    combobox: {
                        optionsFunc: () => {
                            return sendMethodsOptions.map(a => {
                                return { name: a.name, title: a.name, value: a.value };
                            });
                        }
                    },
                    disabled: true,
                    filterable: true,
                    showColumn: false,
                    width: 150
                },
                {
                    title: "تاریخ درخواست",
                    dataIndex: "CreateDateTime",
                    propertyType: enmPropertyType.date,
                    controlType: enmControlType.date,
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "توضیحات",
                    dataIndex: "Description",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.template,
                    disabled: true,
                    filterable: false,
                    showColumn: false,
                    renderControl: (currentEntity: IRepairCase) => {
                        return <TextArea value={currentEntity?.Description} datatype="string" disabled />;
                    }
                }
            ]
        };
    }

    static contextType = AppContext;

    onInitializing() {
        this.searchable = true;
        this.searchArea = {
            columnsPerRow: 2
        };

        this.viewButtonTitle = () => {
            let entity = this.selectedEntity!;
            return entity.RepairationStatus === enmRepairationStatus.CustomerConfirmation ? "مشاهده نتیجه بررسی و اعلام نظر" : "پیگیری درخواست";
        };

        this.originalOrderings = () => [
            { OrderBy: enmOrderingType.Ascending, Property: "Status" },
            { OrderBy: enmOrderingType.Ascending, Property: "RepairationStatus" },
            { OrderBy: enmOrderingType.Descending, Property: "Id" }
        ];

        this.onDataFetching = (fetchingInfo, onViewMode) => {
            fetchingInfo.FetchingDetails = onViewMode;
        };

        this.extraHeaderNodes = () => {
            return (
                this.state.state === enmEntityManagerState.List && <Alert
                    style={{ marginTop: 10, marginBottom: 20, textAlign: 'justify' }}
                    message={
                        <>
                            <span>مشتری گرامی، لطفا جهت مشاهده جزئیات و پیگیری درخواست، روی ردیف مورد نظر کلیک نمایید</span>
                        </>
                    }
                    type="info"
                    icon={<InfoCircleFilled className="blink" />}
                    showIcon
                />
            );
        };

        this.extraViewNode = () => {

            const { currentEntity, repairationSteps } = this.state;
            if (!currentEntity)
                return;

            let steps: React.ReactNode[] = [];

            if (currentEntity.RepairCaseAttachments.length || currentEntity.RepairCaseProblems.length) {
                steps.push(
                    <div key={"RepairCaseMoreInfo"} className="box box-blue" style={{ marginBottom: 10 }}>
                        <div className="box-title">
                            <div className="caption">
                                <Descriptions>
                                    <Descriptions.Item><b>اطلاعات بیشتر</b></Descriptions.Item>
                                    <Descriptions.Item label="تاریخ"><span style={{ direction: "ltr", float: "left" }}>{dayjs(currentEntity.CreateDateTime).calendar('jalali').locale('fa').format("YYYY/MM/DD HH:mm")}</span></Descriptions.Item>
                                    <Descriptions.Item label="کاربر">{currentEntity?.CustomerEquipmentModel.Customer.FullName}</Descriptions.Item>
                                </Descriptions>
                            </div>
                        </div>
                        <div className="box-body form">
                            <div className="form-body">
                                <div style={{ padding: 10 }}>

                                    {!!currentEntity.RepairCaseProblems.length &&
                                        <>
                                            <p>مشکلات دستگاه:</p>
                                            <ProblemsList key={'RepairCaseProblems'} items={currentEntity.RepairCaseProblems.map(p => p.EquipmentProblem.Problem)} />
                                        </>
                                    }
                                    {!!currentEntity.RepairCaseAttachments.length &&
                                        <>
                                            <br />
                                            <AttachmentViewer key={'RepairCaseAttachments'} attachments={currentEntity.RepairCaseAttachments.filter(a => !a.Tag)} />
                                        </>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                );
            }

            let repairCaseCenterId: number | undefined = undefined;
            currentEntity.RepairCaseCenters.forEach(repairCaseCenter => {
                if (repairCaseCenter.Id !== repairCaseCenterId) {
                    repairCaseCenterId = repairCaseCenter.Id;

                    steps.push(
                        <div key={(repairCaseCenter as any).RowGuid} className="box box-blue" style={{ marginBottom: 10 }}>
                            <div className="box-title">
                                <div className="caption">
                                    <Descriptions>
                                        <Descriptions.Item><b>بررسی و تخصیص کارشناس تعمیر</b></Descriptions.Item>
                                        <Descriptions.Item label="تاریخ"><span style={{ direction: "ltr", float: "left" }}>{dayjs(repairCaseCenter.CreateDateTime).calendar('jalali').locale('fa').format("YYYY/MM/DD HH:mm")}</span></Descriptions.Item>
                                        <Descriptions.Item label="کاربر">{repairCaseCenter.Creator?.FullName ?? 'مدیر سیستم'}</Descriptions.Item>
                                    </Descriptions>
                                </div>
                            </div>
                            <div className="box-body form">
                                <div className="form-body">

                                    <RepairationComponents.AssignCenter
                                        repairCase={this.state.currentEntity!}
                                        repairCaseCenter={repairCaseCenter}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>
                    );

                    repairationSteps.filter(s => s.RepairCaseCenterId === repairCaseCenterId)
                        .forEach((s, i) => {
                            let title = repairationStatusOptions.find(o => o.value === s.Substatus)?.name;

                            let repeatedStep = !!repairationSteps.find((v, vIndex) => v.Substatus === s.Substatus && i > vIndex);
                            if (repeatedStep)
                                title += ' (مجدد) ';
                            let dateTime = dayjs(s.CreateDateTime).calendar('jalali').locale('fa').format("YYYY/MM/DD HH:mm");
                            let history: React.ReactNode;
                            let formName = enmRepairationStatus[Number(s.Substatus)];
                            let formProps: IRepairationActionProps<any> = {
                                steps: repairationSteps,
                                entity: s,
                                disabled: true,
                                repairCase: this.state.currentEntity!,
                            };

                            const Component = (RepairationComponents as any)[formName];
                            if (Component) {

                                history = (
                                    <div style={{ padding: 20 }}>
                                        <Component key={s.RowGuid} {...formProps} />
                                    </div>
                                );

                                steps.push(
                                    <div key={s.RowGuid} className="box box-blue" style={{ marginBottom: 10 }}>
                                        <div className="box-title">
                                            <div className="caption">
                                                <Descriptions>
                                                    <Descriptions.Item><b>{title}</b></Descriptions.Item>
                                                    <Descriptions.Item label="تاریخ"><span style={{ direction: "ltr", float: "left" }}>{dateTime}</span></Descriptions.Item>
                                                    <Descriptions.Item label="کاربر">{s.Creator?.FullName ?? 'کارشناس پرونده خسارت'}</Descriptions.Item>
                                                </Descriptions>
                                            </div>
                                        </div>
                                        <div className="box-body form">
                                            <div className="form-body">
                                                {history}
                                            </div>
                                        </div>
                                    </div>
                                );
                            }
                        });
                }
            });

            let userFullName = currentEntity.CustomerEquipmentModel.Customer.FullName;

            const { getUserInfo } = this.context as AppContextProps;
            const { extraVariables } = getUserInfo()!;
            const zobdehLocation: { Longitude?: number; Latitude?: number; Address?: string; WorkTime?: string; CityName?: string; Phone?: string; } = extraVariables['ZobdehLocation'];

            const lastStep = repairationSteps[repairationSteps.length - 1];

            if (currentEntity.Paid === true) {
                const action = (
                    <div style={{ padding: 20 }} ref={node => {
                        if (!!node && this.state.state === enmEntityManagerState.View)
                            node.scrollIntoView({ behavior: "smooth" });
                    }}>
                        <RepairationComponents.Payment key={"Payment"}
                            steps={steps}
                            repairCase={currentEntity}
                            disabled
                            entity={{
                                RepairCaseId: currentEntity.Id,
                                PaymentReceiptDateTime: !!currentEntity.PaymentReceiptDateTime ? dayjs(new Date(currentEntity.PaymentReceiptDateTime)).calendar('jalali') : undefined,
                                PaymentReceipts: currentEntity.RepairCaseAttachments.filter(a => !!a.Tag)
                            }} />
                    </div>
                );

                steps.push(
                    <div key={"Payment"} className="box box-blue" style={{ marginBottom: 10 }}>
                        <div className="box-title">
                            <div className="caption">
                                <Descriptions>
                                    <Descriptions.Item><b>پرداخت</b></Descriptions.Item>
                                </Descriptions>
                            </div>
                        </div>
                        <div className="box-body form">
                            <div className="form-body">
                                {action}
                            </div>
                        </div>
                    </div>
                );
            }
            if (currentEntity.Status === enmRepairCaseStatus.Repairation && currentEntity.RepairationStatus === enmRepairationStatus.RequestCheck) {
                const messageNode = (
                    <div style={{ lineHeight: 2.2 }}>
                        <b>
                            مشتری گرامی، آقا/خانم {userFullName} درخواست تعمیرات آزاد شما با شماره پیگیری {currentEntity.TicketNo} و شماره پرونده {currentEntity.Code} در پورتال شرکت زبده ثبت گردید. نتیجه در اسرع وقت از طریق پیام کوتاه به اطلاع شما خواهد رسید.
                        </b>
                    </div>
                );
                const msg = <div key={"AssignCenter"} className="box" style={{ marginBottom: 10 }}>
                    <div style={{ direction: "rtl" }} ref={node => {
                        if (!!node && !this.state.loading) {
                            node.scrollIntoView({ behavior: "smooth" });
                        }
                    }}>
                        <Alert type="info" style={{ marginTop: 10 }} message={messageNode} />
                    </div>
                </div>
                steps.push(msg);
            }
            else if (currentEntity.Status === enmRepairCaseStatus.Rejected && currentEntity.RepairationStatus === enmRepairationStatus.Rejected) {
                const messageNode = (
                    <div style={{ lineHeight: 2.2 }}>
                        <b>
                            مشتری گرامی، آقا/خانم {userFullName} درخواست تعمیرات شماره {currentEntity.TicketNo} بررسی گردید، متأسفانه در حال حاضر قادر به ارائه خدمات به شما نیستیم. از اینکه ما را انتخاب کردید سپاسگزاریم.
                        </b>
                    </div>
                );
                const msg = <div key={"AssignCenter"} className="box" style={{ marginBottom: 10 }}>
                    <div style={{ direction: "rtl" }} ref={node => {
                        if (!!node && !this.state.loading) {
                            node.scrollIntoView({ behavior: "smooth" });
                        }
                    }}>
                        <Alert type="info" style={{ marginTop: 10 }} message={messageNode} />
                    </div>
                </div>
                steps.push(msg);
            }
            else if (currentEntity.RepairationStatus === enmRepairationStatus.SendDevice) {
                const messageNode = (
                    <div style={{ lineHeight: 2.2 }}>
                        <p>
                            مشتری گرامی، آقا/خانم {userFullName} درخواست تعمیر شماره {currentEntity.TicketNo} بررسی و مورد تأیید است. خواهشمند است دستگاه آسیب دیده خود را به آدرس زیر ارسال نمایید
                        </p>

                        <CenterLocation {...zobdehLocation} />
                    </div>
                );
                const msg = <div key={"CustomerPanelMessage"} className="box" style={{ marginBottom: 10 }}>
                    <div style={{ direction: "rtl" }} ref={node => {
                        if (!!node && !this.state.loading) {
                            node.scrollIntoView({ behavior: "smooth" });
                        }
                    }}>
                        <Alert type="info" style={{ marginTop: 10 }} message={messageNode} />
                    </div>
                </div>
                steps.push(msg);
            }
            else if (currentEntity.RepairationStatus === enmRepairationStatus.Estimation) {
                const messageNode = (
                    <div style={{ lineHeight: 2.2 }}>
                        <div>
                            مشتری گرامی، آقا/خانم {userFullName} دستگاه شما با درخواست تعمیر {currentEntity.TicketNo} جهت بررسی و انجام اقدامات لازم دریافت گردید. نتیجه در اسرع وقت از طریق پیام کوتاه به شما اطلاع رسانی خواهد شد.
                        </div>
                    </div>
                );
                const msg = <div key={"CustomerPanelMessage"} className="box" style={{ marginBottom: 10 }}>
                    <div style={{ direction: "rtl" }} ref={node => {
                        if (!!node && !this.state.loading) {
                            node.scrollIntoView({ behavior: "smooth" });
                        }
                    }}>
                        <Alert type="info" style={{ marginTop: 10 }} message={messageNode} />
                    </div>
                </div>
                steps.push(msg);
            }
            else if (currentEntity.RepairationStatus === enmRepairationStatus.Rejected && currentEntity.Status === enmRepairCaseStatus.ReturnDevice) {
                const messageNode = (
                    <div style={{ lineHeight: 2.2 }}>
                        <p>
                            مشتری گرامی، آقا/خانم {userFullName} درخواست تعمیرات شماره {currentEntity.TicketNo} بررسی گردید، متأسفانه در حال حاضر قادر به ارائه خدمات به شما نیستیم. خواهشمند است با مراجعه به آدرس زیر نسبت به دریافت دستگاه اقدام نمایید
                        </p>

                        <CenterLocation {...zobdehLocation} />
                    </div>
                );
                const msg = <div key={"CustomerPanelMessage"} className="box" style={{ marginBottom: 10 }}>
                    <div style={{ direction: "rtl" }} ref={node => {
                        if (!!node && !this.state.loading) {
                            node.scrollIntoView({ behavior: "smooth" });
                        }
                    }}>
                        <Alert type="info" style={{ marginTop: 10 }} message={messageNode} />
                    </div>
                </div>
                steps.push(msg);
            }
            else if (currentEntity.RepairationStatus === enmRepairationStatus.CustomerConfirmation) {
                const estimatedAmount = lastStep.EstimatedAmount;
                const messageNode = (
                    <div style={{ lineHeight: 2.2 }}>
                        <div>
                            <b>
                                مشتری گرامی، آقا/خانم {userFullName} درخواست تعمیر شماره {currentEntity.TicketNo} برآورد هزینه گردید. طبق نظر کارشناس تعمیرات، هزینه  تعمیرات <span>{`${estimatedAmount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</span> ریال است. خواهشمند است در اسرع وقت نظر خود را در این خصوص اعلام نمایید.
                            </b>
                        </div>
                    </div>
                );

                const msg = <div key={"CustomerPanelMessage"} className="box" style={{ marginBottom: 10 }}>
                    <div style={{ direction: "rtl" }} ref={node => {
                        if (!!node && !this.state.loading) {
                            node.scrollIntoView({ behavior: "smooth" });
                        }
                    }}>
                        <Alert type="info" style={{ marginTop: 10 }} message={messageNode} />
                    </div>
                </div>
                steps.push(msg);

                const action = (
                    <div key="CustomerConfirmation" className="box box-blue" style={{ marginBottom: 10 }}>
                        <div className="box-title">
                            <div className="caption">
                                <Descriptions >
                                    <Descriptions.Item style={{ padding: 10 }}><b>اعلام نظر مشتری</b></Descriptions.Item>
                                </Descriptions>
                            </div>
                        </div>
                        <div className="box-body form">
                            <div className="form-body">
                                <div style={{ padding: 0, direction: "rtl" }} ref={node => {
                                    if (!!node && !this.state.loading) {
                                        node.scrollIntoView({ behavior: "smooth" });
                                    }
                                }}>
                                    <CustomerConfirmation
                                        steps={repairationSteps}
                                        repairCase={currentEntity!}
                                        onClose={arg => arg && arg.preventBack === true ? this.view(this.state.currentEntity!.RowGuid) : this.back()}
                                        onSubmit={async ({ data, url, contentType, headers, completeCallback }) => {
                                            let fetchOpt: ICallOptions = {
                                                url,
                                                data,
                                                contentType,
                                                headers,
                                                onSuccess: async (result: IResultSet<any>) => {
                                                    completeCallback(result);
                                                }
                                            };
                                            await this.callApi(fetchOpt);
                                        }} />
                                </div>
                            </div>
                        </div>
                    </div>
                );
                steps.push(action);
            }
            else if (currentEntity.Status === enmRepairCaseStatus.ReturnDevice && currentEntity.RepairationStatus === enmRepairationStatus.CustomerRejected) {
                const messageNode = (
                    <div style={{ lineHeight: 2.2 }}>
                        <p>
                            مشتری گرامی، آقا/خانم {userFullName} با توجه به انصراف شما از تعمیرات خواهشمند است با مراجعه به آدرس زیر نسبت به دریافت دستگاه اقدام نمایید
                        </p>

                        <CenterLocation {...zobdehLocation} />
                    </div>
                );
                const msg = <div key={"CustomerPanelMessage"} className="box" style={{ marginBottom: 10 }}>
                    <div style={{ direction: "rtl" }} ref={node => {
                        if (!!node && !this.state.loading) {
                            node.scrollIntoView({ behavior: "smooth" });
                        }
                    }}>
                        <Alert type="info" style={{ marginTop: 10 }} message={messageNode} />
                    </div>
                </div>
                steps.push(msg);
            }
            else if (currentEntity.RepairationStatus === enmRepairationStatus.RepairationComplete) {
                const messageNode = (
                    <div style={{ lineHeight: 2.2 }}>
                        <b>
                            مشتری گرامی، آقا/خانم {userFullName} تعمیرات دستگاه شما انجام و در اسرع وقت نتیجه حضورتان از طریق پیام کوتاه اطلاع رسانی میگردد.
                        </b>
                    </div>
                );
                const msg = <div key={"CustomerPanelMessage"} className="box" style={{ marginBottom: 10 }}>
                    <div style={{ direction: "rtl" }} ref={node => {
                        if (!!node && !this.state.loading) {
                            node.scrollIntoView({ behavior: "smooth" });
                        }
                    }}>
                        <Alert type="info" style={{ marginTop: 10 }} message={messageNode} />
                    </div>
                </div>
                steps.push(msg);
            }
            else if (currentEntity.Status === enmRepairCaseStatus.ReturnDevice && currentEntity.RepairationStatus === enmRepairationStatus.Failed) {
                const messageNode = (
                    <div style={{ lineHeight: 2.2 }}>
                        <p>
                            مشتری گرامی، آقا/خانم {userFullName} درخواست تعمیرات به شماره {currentEntity.TicketNo} غیرقابل تعمیر است، خواهشمند است در اسرع وقت نسبت به دریافت دستگاه خود به آدرس زیر مراجعه نمایید
                        </p>

                        <CenterLocation {...zobdehLocation} />
                    </div>
                );
                const msg = <div key={"CustomerPanelMessage"} className="box" style={{ marginBottom: 10 }}>
                    <div style={{ direction: "rtl" }} ref={node => {
                        if (!!node && !this.state.loading) {
                            node.scrollIntoView({ behavior: "smooth" });
                        }
                    }}>
                        <Alert type="info" style={{ marginTop: 10 }} message={messageNode} />
                    </div>
                </div>
                steps.push(msg);
            }
            else if ([enmRepairCaseStatus.Payment].indexOf(currentEntity.Status) > -1 && currentEntity.RepairationStatus === enmRepairationStatus.Completed) {
                const messageNode = (
                    <div style={{ lineHeight: 2.2 }}>
                        <b>
                            مشتری گرامی، آقا/خانم {userFullName} درخواست تعمیرات به شماره {currentEntity.TicketNo} انجام شد و مشکل دستگاه شما رفع گردیده است. خواهشمند است جهت دریافت دستگاه و پرداخت هزینه به آدرس زیر مراجعه نمایید
                        </b>

                        <CenterLocation {...zobdehLocation} />
                    </div>
                );
                const msg = <div key={"CustomerPanelMessage"} className="box" style={{ marginBottom: 10 }}>
                    <div style={{ direction: "rtl" }} ref={node => {
                        if (!!node && !this.state.loading) {
                            node.scrollIntoView({ behavior: "smooth" });
                        }
                    }}>
                        <Alert type="info" style={{ marginTop: 10 }} message={messageNode} />
                    </div>
                </div>
                steps.push(msg);
            }
            else if (currentEntity.RepairationStatus === enmRepairationStatus.Rejected && currentEntity.Status === enmRepairCaseStatus.ReturnDevice && currentEntity.DeviceReturned !== true) {
                const messageNode = (
                    <div style={{ lineHeight: 2.2 }}>
                        <p>
                            مشتری گرامی، آقا/خانم {userFullName} درخواست تعمیرات شماره {currentEntity.TicketNo} بررسی گردید، متأسفانه در حال حاضر قادر به ارائه خدمات به شما نیستیم. خواهشمند است با مراجعه به آدرس زیر نسبت به دریافت دستگاه اقدام نمایید
                        </p>

                        <CenterLocation {...zobdehLocation} />
                    </div>
                );
                const msg = <div key={"CustomerPanelMessage"} className="box" style={{ marginBottom: 10 }}>
                    <div style={{ direction: "rtl" }} ref={node => {
                        if (!!node && !this.state.loading) {
                            node.scrollIntoView({ behavior: "smooth" });
                        }
                    }}>
                        <Alert type="info" style={{ marginTop: 10 }} message={messageNode} />
                    </div>
                </div>
                steps.push(msg);
            }

            if (currentEntity.Paid === true) {
                let returnDate = !!currentEntity.PaymentReceiptDateTime 
                    ? dayjs(currentEntity.PaymentReceiptDateTime).calendar('jalali').locale('fa').format("YYYY/MM/DD")
                    : dayjs(currentEntity.CreateDateTime).calendar('jalali').locale('fa').format("YYYY/MM/DD");

                const messageNode = (
                    <div style={{ lineHeight: 2.2 }}>
                        <b>
                            هزینه تعمیرات در تاریخ <b>{returnDate}</b> پرداخت شد
                        </b>
                    </div>
                );
                const msg = <div key={"PaymentMessage"} className="box" style={{ marginBottom: 10 }}>
                    <div style={{ direction: "rtl" }}>
                        <Alert type="info" style={{ marginTop: 10 }} message={messageNode} />
                    </div>
                </div>
                steps.push(msg);
            }

            if (currentEntity.DeviceReturned === true) {
                let returnDate = dayjs(currentEntity.DeviceReturnedDateTime).calendar('jalali').locale('fa').format("YYYY/MM/DD");
                const messageNode = (
                    <div style={{ lineHeight: 2.2 }}>
                        {currentEntity.Paid === true
                            ?
                            <p>
                                مشتری گرامی، آقا/خانم <b>{userFullName}</b> درخواست تعمیرات شماره <b>{currentEntity.TicketNo}</b> با موفقیت انجام و دستگاه در تاریخ <b>{returnDate}</b> تحویل مشتری گردید.  از اینکه ما را انتخاب کرده‌اید سپاسگزاریم
                            </p>
                            :
                            <p>
                                دستگاه در تاریخ <b>{returnDate}</b> به مشتری تحویل داده شد
                            </p>
                        }
                    </div>
                );
                const msg = <div key={"DeviceReturnedMessage"} className="box" style={{ marginBottom: 10 }}>
                    <div style={{ direction: "rtl" }}>
                        <Alert type="info" style={{ marginTop: 10 }} message={messageNode} />
                    </div>
                </div>
                steps.push(msg);
            }

            if (currentEntity.Status === enmRepairCaseStatus.Archived) {
                const messageNode = (
                    <div style={{ lineHeight: 2.2 }}>
                        <b>
                            درخواست بسته شد
                        </b>
                    </div>
                );
                const msg = <div key={"ClosedMessage"} className="box" style={{ marginBottom: 10 }}>
                    <div style={{ direction: "rtl" }}>
                        <Alert type="info" style={{ marginTop: 10 }} message={messageNode} />
                    </div>
                </div>
                steps.push(msg);
            }

            return (
                <>
                    {steps}
                </>
            );
        };

    }

    onEntityView = (entity: IRepairCase) => {
        let fetchOpt: ICallOptions = {
            url: "repaircasepolicyholder/getallrepairationsteps",
            data: { repairCaseId: entity.Id },
            onSuccess: (result: IResultSet<any>) => {
                if (!result.ValidationState.Successful)
                    return;
                this.setState({ state: enmEntityManagerState.View, currentEntity: entity, repairationSteps: result.Data.steps });
            },
            onError: () => {

            }
        };
        this.callApi(fetchOpt);
        return false;
    }
}